(function () {
  'use strict';

  var drawerSelector = '[data-cart-line-edit-drawer]';
  var buttonSelector = '[data-cart-edit-button]';

  function rootPath() {
    var configuredRoot = window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.rootUrl;
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (configuredRoot || shopifyRoot || '/').replace(/\/?$/, '/');
  }

  function shopifyUrl(path) {
    return rootPath() + String(path).replace(/^\/+/, '');
  }

  function notify(drawer, message, isError) {
    var status = drawer.querySelector('[data-cart-line-edit-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'text--small';
      status.setAttribute('data-cart-line-edit-status', '');
      var form = drawer.querySelector('form');
      if (form) form.parentNode.insertBefore(status, form);
    }
    status.textContent = message || '';
    if (isError) status.setAttribute('data-error', '');
    else status.removeAttribute('data-error');
  }

  function setFormDefaults(drawer, force) {
    var form = drawer.querySelector('form');
    if (!form) return;
    if (!force && form === drawer.cartLineEditForm) return;

    drawer.cartLineEditForm = form;

    var quantity = form.elements.namedItem('quantity');
    if (quantity) quantity.value = drawer.cartLineEditQuantity || drawer.dataset.cartEditQuantity || '1';

    var submit = form.querySelector('[data-product-add-to-cart-button]');
    if (submit) {
      submit.textContent = 'Update';
      submit.setAttribute('data-cart-line-edit-submit', '');
    }
    notify(drawer, '', false);
  }

  // Changing an option makes the theme re-render the quick-buy content, which swaps the form, restores the
  // product's default quantity and relabels the submit button. Re-apply the edit context on that new form.
  function rememberQuantity(event) {
    var target = event.target;
    if (!target || target.name !== 'quantity') return;
    var drawer = target.closest(drawerSelector);
    if (drawer) drawer.cartLineEditQuantity = target.value;
  }

  function readFormData(form, drawer) {
    var data = new FormData(form);
    var variantInput = form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var sellingPlanInput = form.querySelector('[name="selling_plan"]');
    var optionInputs = drawer ? Array.prototype.slice.call(drawer.querySelectorAll('input[data-option-position]:checked, select[data-option-position]')) : [];
    optionInputs.sort(function (first, second) {
      return Number(first.getAttribute('data-option-position')) - Number(second.getAttribute('data-option-position'));
    });
    var options = optionInputs.map(function (input) {
      if (input.tagName === 'SELECT') {
        var selectedOption = input.options[input.selectedIndex];
        return selectedOption ? selectedOption.textContent.trim().replace(/\s+-\s+\$[\d,.]+$/, '') : input.value;
      }
      var label = input.id && document.querySelector('label[for="' + input.id + '"]');
      return label ? label.textContent.trim() : (input.dataset.value || input.value);
    });
    var properties = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = String(value);
    });
    return {
      id: variantInput ? variantInput.value : data.get('id'),
      quantity: quantityInput ? quantityInput.value : data.get('quantity'),
      sellingPlan: sellingPlanInput ? sellingPlanInput.value : data.get('selling_plan'),
      options: options,
      properties: properties
    };
  }

  async function resolveVariantId(drawer, formData) {
    var fallbackId = Number(formData.id);
    var picker = drawer.querySelector('variant-picker[handle]');
    if (!picker || !formData.options.length) return fallbackId;

    var response = await fetch(shopifyUrl('products/' + encodeURIComponent(picker.getAttribute('handle')) + '.js'), {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) return fallbackId;
    var product = await response.json();
    var selected = product.variants.find(function (variant) {
      return formData.options.every(function (option, index) {
        return variant.options && String(variant.options[index]).trim() === String(option).trim();
      });
    });
    return selected ? Number(selected.id) : fallbackId;
  }

  function sameProperties(first, second) {
    var firstKeys = Object.keys(first || {}).sort();
    var secondKeys = Object.keys(second || {}).sort();
    if (firstKeys.length !== secondKeys.length) return false;
    return firstKeys.every(function (key, index) {
      return key === secondKeys[index] && String(first[key]) === String(second[key]);
    });
  }

  function updateSelectionKey(oldKey, newKey) {
    try {
      var raw = window.localStorage.getItem('ever-pretty:partial-checkout:selection:v1');
      if (!raw) return;
      var selection = JSON.parse(raw);
      if (!selection || typeof selection !== 'object' || !Object.prototype.hasOwnProperty.call(selection, oldKey)) return;
      selection[newKey] = selection[oldKey];
      delete selection[oldKey];
      window.localStorage.setItem('ever-pretty:partial-checkout:selection:v1', JSON.stringify(selection));
    } catch (error) {
      // Selection persistence is optional; cart editing must still complete.
    }
  }

  async function fetchCart() {
    var response = await fetch(shopifyUrl('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to read your cart. Please refresh and try again.');
    return response.json();
  }

  async function replaceLine(drawer, form) {
    var formData = readFormData(form, drawer);
    var variantId = await resolveVariantId(drawer, formData);
    var quantity = Math.max(1, Number(formData.quantity || drawer.dataset.cartEditQuantity || 1));
    if (!variantId) throw new Error('Please select an available product option.');

    var cart = await fetchCart();
    var original = cart.items.find(function (item) { return item.key === drawer.dataset.cartEditLineKey; });
    if (!original) throw new Error('This cart item changed. Please refresh and try again.');

    var properties = Object.assign({}, original.properties || {}, formData.properties || {});
    var sellingPlan = formData.sellingPlan || original.selling_plan;
    var fee = null;
    if (original.properties && original.properties._processing_option === 'rush') {
      fee = cart.items.find(function (item) {
        return item.properties && item.properties._processing_role === 'fee' &&
          item.properties._processing_link_id === original.properties._processing_link_id &&
          String(item.properties._processing_for_variant_id) === String(original.variant_id) &&
          String(item.variant_id) === String(original.properties._processing_fee_variant_id);
      });
    }

    if (variantId === Number(original.variant_id) && quantity === Number(original.quantity) &&
        String(sellingPlan || '') === String(original.selling_plan || '') && sameProperties(properties, original.properties || {})) {
      drawer.open = false;
      return null;
    }

    var replacement = { id: variantId, quantity: quantity, properties: properties };
    if (sellingPlan) replacement.selling_plan = sellingPlan;
    var items = [replacement];
    var oldKeys = [original.key];
    if (fee) {
      oldKeys.push(fee.key);
      items.push({
        id: fee.variant_id,
        quantity: fee.quantity,
        properties: Object.assign({}, fee.properties, { _processing_for_variant_id: String(variantId) })
      });
    }

    var addResponse = await fetch(shopifyUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    });
    var added = await addResponse.json();
    if (!addResponse.ok) throw new Error(added.description || 'The selected option could not be added.');

    var updates = {};
    oldKeys.forEach(function (key) { updates[key] = 0; });
    var removeResponse = await fetch(shopifyUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    });
    if (!removeResponse.ok) throw new Error('The previous cart item could not be replaced. Please refresh your cart.');

    var addedMain = (added.items || []).find(function (item) { return String(item.variant_id) === String(variantId); });
    if (addedMain) updateSelectionKey(original.key, addedMain.key);
    return true;
  }

  function finishRefresh(drawer) {
    drawer.open = false;
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
  }

  async function handleSubmit(event) {
    var form = event.target;
    var drawer = form.closest(drawerSelector);
    if (!drawer || drawer.dataset.cartLineEditBusy === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.dataset.cartLineEditBusy = 'true';
    var buttons = Array.prototype.slice.call(form.querySelectorAll('button, input, select, textarea'));
    buttons.forEach(function (element) { element.disabled = true; });
    notify(drawer, 'Updating your cart…', false);
    try {
      var changed = await replaceLine(drawer, form);
      if (changed) finishRefresh(drawer);
    } catch (error) {
      notify(drawer, error.message, true);
    } finally {
      delete drawer.dataset.cartLineEditBusy;
      buttons.forEach(function (element) { element.disabled = false; });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(buttonSelector);
    if (!button) return;
    var drawer = document.getElementById(button.dataset.cartEditDrawerId);
    if (drawer) drawer.dataset.cartEditLineKey = button.closest('[data-cart-edit-line-key]')?.dataset.cartEditLineKey || drawer.dataset.cartEditLineKey;
  }, true);

  function bindDrawer(drawer) {
    if (drawer.dataset.cartLineEditBound === 'true') return;
    drawer.dataset.cartLineEditBound = 'true';

    drawer.addEventListener('openable-element:load:end', function () {
      drawer.cartLineEditForm = null;
      drawer.cartLineEditQuantity = drawer.dataset.cartEditQuantity || '1';
      setFormDefaults(drawer, true);
    });

    drawer.addEventListener('input', rememberQuantity, true);
    drawer.addEventListener('change', rememberQuantity, true);

    new MutationObserver(function () {
      setFormDefaults(drawer, false);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function bindDrawers() {
    document.querySelectorAll(drawerSelector).forEach(bindDrawer);
  }

  bindDrawers();
  new MutationObserver(bindDrawers).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('submit', handleSubmit, true);
})();
